module.exports = __webpack_public_path__ + "stu-res/img/icon-1.37b483e8.png";